import React from 'react';
import { Tooltip } from '@planne-software/uni/Tooltip';
import { Box } from '@planne-software/uni/mui/material';

import { SequentialSlotHighlightFrame } from './styles';
import { ProductBookingSlot } from '../../types/productBookingSlot';
import { useProductBookingSequential } from '../../hooks/useProductBookingSequential';

type SequentialSlotShellProps = {
  slot: ProductBookingSlot | null;
  children: React.ReactNode;
};

export const SequentialSlotShell = ({ slot, children }: SequentialSlotShellProps) => {
  const seq = useProductBookingSequential();

  if (!slot) {
    return children;
  }

  const { visual } = seq;
  const highlighted = visual.highlightedSlot === slot;
  const tooltipForThisRow = visual.tooltipAnchor === slot && visual.tooltipOpen && Boolean(visual.tooltipTitle);

  return (
    <SequentialSlotHighlightFrame highlighted={highlighted}>
      <Tooltip
        describeChild
        label={visual.tooltipTitle}
        open={tooltipForThisRow}
        placement='bottom'
        disableFocusListener
        disableHoverListener
        disableTouchListener
        arrow
      >
        <Box sx={{ width: '100%' }}>{children}</Box>
      </Tooltip>
    </SequentialSlotHighlightFrame>
  );
};
